export enum SearchBarOptionsValues {
	SEARCHBAR = 'Search Bar',
	GREETING = 'Greeting',
	MYFOCUS = 'MY Focus'
}

export enum SearchBarStyleValues {
	ROUNDED = 'rounded',
	RECTANGLE = 'rectangle',
	LINE = 'line'
}

export enum SelectedBookmarks {
	CHROME_BOOKMAKRS = 'Chrome',
	USER_BOOKMAKRS = 'User',
	TOP_VISITED = 'Top Sites',
	TOPIC_DEFAULT = 'Topic'
}

export enum ClockTypes {
	Analog = 'AnalogClockStyle',
	Digital = 'DigitalClockStyle',
	AgeCounter = 'AgeCounterStyle'
}

export enum SidebarBackgroundValues {
	SOLID = 'solid',
	FLOATING = 'floating'
}

export enum BackgroundValues {
	PICTURE = 'picture',
	DARK = 'dark',
	LIGHT = 'light'
}

export enum ModeValues {
	DARK = 'dark',
	LIGHT = 'light',
	SYSTEM = 'system'
}

export enum OpacityValues {
	OPAQUE = 'opaque',
	TRANSLUCENT = 'translucent',
	TRANSPARENT = 'transparent'
}

export enum ViewValues {
	EXPANDED = 'expanded',
	CONTRACTED = 'contracted'
}

export enum FontValues {
	STANDARD = 'standard',
	CLASSIC = 'classic',
	ARTISTIC = 'artistic'
}
